import {
  BUTTON_TYPES,
  BpkButtonV2,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkDialog from '@skyscanner/backpack-web/bpk-component-dialog';
import BpkExclamationIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/exclamation';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../contexts/i18n';

import type { OnSavedStatusChanged } from '@shared/types/frontend/save-to-list';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './SaveLimitErrorDialog.module.scss';

import { SAVED_STATUS } from '@shared/constants/save-status';
import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';

const cls = cssModules(STYLES);

type Props = {
  isOpen: boolean;
  headingText?: string;
  subHeadingText?: string;
  i18n: I18nService;
  onSavedStatusChanged: OnSavedStatusChanged;
};

const SaveLimitErrorDialog = ({
  headingText,
  i18n: { translate },
  isOpen,
  onSavedStatusChanged,
  subHeadingText,
}: Props) => (
  <BpkDialog
    className={cls('SaveLimitErrorDialog')}
    getApplicationElement={getApplicationElement}
    id="save-limit-error-dialog"
    ariaLabel="reached save limit"
    headerIconType="warning"
    headerIcon={<BpkExclamationIcon />}
    dismissible={false}
    isOpen={isOpen}
    ariaModal
  >
    <div>
      <BpkText tagName="h3" textStyle={TEXT_STYLES.heading3}>
        {headingText}
      </BpkText>
      <BpkText
        className={cls('SaveLimitErrorDialog__subHeading')}
        tagName="p"
        textStyle={TEXT_STYLES.bodyDefault}
      >
        {subHeadingText}
      </BpkText>
      <BpkButtonV2
        className={cls('SaveLimitErrorDialog__closeButton')}
        type={BUTTON_TYPES.featured}
        size={SIZE_TYPES.large}
        onClick={() => {
          onSavedStatusChanged({
            payload: {},
            saveStatus: SAVED_STATUS.RESET,
          });
        }}
      >
        <BpkText tagName="p" textStyle={TEXT_STYLES.label1}>
          {translate('hotel_coupon_hint_button_ok')}
        </BpkText>
      </BpkButtonV2>
    </div>
  </BpkDialog>
);

export default withI18n(SaveLimitErrorDialog);
